/**
 * Vérifie si une string est une URL Vinted catalog valide
 * Supporte tous les domaines Vinted (vinted.fr, vinted.es, vinted.de, vinted.co.uk, etc.)
 */
export const isVintedCatalogUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return /^(www\.)?vinted\.\w+(\.\w+)?$/.test(parsed.hostname) && parsed.pathname.includes('/catalog');
  } catch {
    return false;
  }
};
